import HourglassEmptyRoundedIcon from '@mui/icons-material/HourglassEmptyRounded';
import SendIcon from '@mui/icons-material/Send';
import RotateRightIcon from '@mui/icons-material/RotateRight';
import DoneRoundedIcon from '@mui/icons-material/DoneRounded';

export const PURCHASE_STATUSES = ['SEND', 'WAITING', 'PROCESSING', 'COMPLETED'];

export const PURCHASE_ICONS = {
  send: SendIcon,
  waiting: HourglassEmptyRoundedIcon,
  processing: RotateRightIcon,
  completed: DoneRoundedIcon,
};
export const PURCHASE_COLORS = {
  send: '#1D5B9D',
  waiting: '#fca600',
  processing: '#ff6700',
  completed: '#34A853',
};

export const PURCHASE_SORTING = [
  {
    label: 'PURCHASE_STATE',
    value: 'purchaseStateID',
    isDefault: true,
  },
  {
    label: 'CREDIT_SMS_QUANTITY',
    value: 'creditsSMSQuantity',
  },
  {
    label: 'COST',
    value: 'cost',
  },
  {
    label: 'PURCHASE_CONFIRM_DATE',
    value: 'purchaseConfirmDate',
  },
  {
    label: 'PURCHASE_REQUEST_DATE',
    value: 'purchaseRequestDate',
  },
];
